下游付款详情
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- start of title -->
    <div class="title-box">
      <el-button type="default" size="mini" @click="goBack">返回</el-button>
      <span>
        {{ isThirdPartyContractor ? '下游收款流程' : '付款申请流程' }}
      </span>
    </div>
    <!-- end of title -->

    <!-- start of form -->
    <div class="form-box">
      <!-- start of 付款申请信息 -->
      <div style="position: relative" class="back-color-fff mt-4">
        <span class="form-title">付款申请信息</span>
        <span class="form-title" v-if="formData.approveVO&&formData.approveVO.flowNo">- {{ formData.approveVO.flowNo }}</span>
        <PayerInfo
          :formData="formData" 
          :paymentSettleList="paymentSettleList"
          :isLastNodePass="isLastNodePass"
          :isInvoicedCom="isInvoicedCom"
          :isMultiplePayBank="isMultiplePayBank"
          :oldServiceTenantName="oldServiceTenantName"
          :newServiceTenantName="newServiceTenantName"
          :oneCardMultipleTickets="oneCardMultipleTickets"
          :getName="getName"
          @seeDetail="seeDetail"
          @onPreview="onPreview"
          @onDownload="onDownload"
          @onViewUpstreamOperationReportDetail="onViewUpstreamOperationReportDetail"
        >
        </PayerInfo>
        <img
          v-show="formData.approveVO && formData.approveVO.approveState !== 'N'"
          class="approve-img"
          :src="getApproveImg()"
          alt=""
        />
      </div>
      <!-- end of 付款申请信息 -->

      <!-- start of 收款方信息 -->
      <div style="position: relative" class="back-color-fff mt-4">
        <span class="form-title-item">收款方及其他信息</span>
        <el-form :model="formData" ref="formData">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label-width="122px">
                <span slot="label"> <span style="color: red">*</span>收款方： </span>
                {{ formData.tenantName || '-' }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="receiveBankName" label-width="122px">
                <span slot="label"> <span style="color: red">*</span>收款开户银行： </span>
                {{ formData.receiveBankName || '-' }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="receiveBankAccount" label-width="122px">
                <span slot="label"> <span style="color: red">*</span>收款银行账户： </span>
                {{ formData.receiveBankAccount || '-' }}
                <!-- <el-input oninput="value=value.replace(/[^\d\s]/g, '')"
                                    v-model="formData.receiveBankAccount" placeholder="请填写收款开户银行" size="mini" /> -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8" style="margin-left: -20px;">
              <el-form-item prop="payTime" label-width="140px">
                <span slot="label">
                  <span style="color: red">*</span>申请付款日期<el-tooltip
                    class="item"
                    effect="dark"
                    content="平台支付给供应商的时间"
                    placement="right-start"
                    ><i class="el-icon-question"></i></el-tooltip
                  >：
                </span>
                {{ formData.payTime | getDate }}

                <!-- <el-date-picker size="mini" v-model="formData.payTime" type="date" format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd" placeholder="选择付款时间">
                                </el-date-picker> -->
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="isRepay" label-width="140px">
                <span slot="label"> <span style="color: red">*</span>是否回款： </span>
                {{ formData.isRepay == 'Y' ? '是' : '否' }}
                <!-- <el-select style="width:220px" v-model="formData.isRepay" placeholder="是否已开票" size="mini">

                                    <el-option label="是" value="Y"></el-option>
                                    <el-option label="否" value="N"></el-option>
                                </el-select> -->
              </el-form-item>
            </el-col>
            <!-- //!应付金额的取数逻辑之前来自结算单的费用总额字段，现在要换成结算单的应付金额 -->
            <el-col :span="8">
              <el-form-item label="" label-width="140px">
                <span slot="label"> <span style="color: red">*</span>应付金额(元)： </span>
                <span style="color: #ff5f1f">{{ formData.payAmount ? formatMoney(formData.payAmount) : '-' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="" label-width="122px">
                <span slot="label"> 是否平台专属： </span>
                <div style="width: 600px">{{ formData.taskBelongCategory === 3 ? '是' : '否' }}</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="" label-width="122px">
                <span slot="label"> 备注说明： </span>
                <span style="color: red;">{{ formData.memo }}</span><span>{{ formData.memo ?'': '-' }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" v-if="formData.isRepay == 'Y'">
            <el-col :span="24">
              <el-form-item prop="upstreamInvoiceItem" label-width="122px">
                <span slot="label"> <span style="color: red">*</span>关联上游收款： </span>
                <div
                  style="width: 600px"
                  v-html="Array.isArray(formData.upstreamInvoiceItem) ? '-' : formData.upstreamInvoiceItem"
                ></div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" v-if="formData.isRepay == 'Y'">
            <el-col :span="24">
              <el-form-item prop="upstreamInvoiceItem" label-width="122px">
                <span slot="label"> 关联下游退款： </span>
                <div
                  style="width: 600px"
                  v-html="Array.isArray(formData.downstreamBackInvoiceItem) ? '-' : formData.downstreamBackInvoiceItem"
                ></div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item prop="upstreamInvoiceItem" label-width="122px">
                <span slot="label"> <span style="color: red">*</span>附件： </span>
                <div class="file-operate" v-for="file in formData.paymentAttaches" :key="file.path">
                  <div class="file-name">{{ file.fileName }}</div>
                  <div class="file-preview" @click="onPreview(file)">查看</div>
                  <div class="file-preview" @click="download(file.path,file.name,file.fileName)">下载</div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          
        </el-form>
      </div>
      <!-- end of 收款方信息 -->

      <!-- start of 财务信息 -->
      <!-- 新数据不展示财务信息 -->
      <!-- <div class="back-color-fff mt-4"
        v-if="JSON.parse($route.query.approveVO).approveState == 'Y' && isInvoicedCom"
      >
        <span class="form-title"> 财务信息 </span>
        <el-form :model="formData" ref="formData">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label-width="110px" prop="relevance">
                <span slot="label"> <span style="color: red"> </span>开票时间： </span>
                {{ formData.invoiceDate | getDate }}
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label-width="122px">
                <span slot="label"> <span style="color: red"> </span>税率(%)： </span>
                {{ formData.taxRate || '-' }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="24">
            <el-col :span="24">
              <el-form-item prop="upstreamInvoiceItem" label-width="122px">
                <span slot="label"> <span style="color: red"> </span>票据附件： </span>
                {{ formData.invoiceAttaches? '' : '-' }}
                <div class="file-operate" v-for="file in formData.invoiceAttaches" :key="file.path">
                  <div class="file-name">{{ file.fileName || '-' }}</div>
                  <div class="file-preview" @click="onPreview(file)">查看</div>
                  <div class="file-preview" @click="download(file.path,file.name,file.fileName)">下载</div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="24">
            <el-col :span="24">
              <el-form-item prop="upstreamInvoiceItem" label-width="122px">
                <span slot="label"> <span style="color: red">*</span>结算单附件： </span>
                <div class="file-operate" v-for="file in formData.settleAttaches" :key="file.path">
                  <div class="file-name">{{ file.fileName || '-' }}</div>
                  <div class="file-preview" @click="onPreview(file)">查看</div>
                  <div class="file-preview" @click="download(file.path,file.name,file.fileName)">下载</div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          
        </el-form>
      </div> -->
      <!-- end of 财务信息 -->

      <!-- 开票信息 -->
      <div class="back-color-fff mt-4" v-if="isLastNodePass">
        <BillingInformation  
          :formData="formData" 
        />
      </div>

      <!-- start of 流程审批 -->
      <div class="back-color-fff mt-4">
        <!-- <span class="form-title">流程审批</span> -->
        <div class="flow">
          <approval-process
            v-if="formData.approveVO"
            :approveVO="formData.approveVO"
            flow-type="00022"
          />
        </div>
      </div>
      <!-- end of 流程审批 -->

      <!-- start of bottom-btn -->
      <div class="back-color-fff submit_btn_wrap">
        <el-button type="defalut" class="cannel-btn" size="mini" @click="goBack">取消</el-button>
        <el-button type="danger" size="mini" v-show="getBtnState('approval') == 'approval'" @click="reject()"
          >驳回</el-button
        >
        <el-button type="primary" size="mini" v-show="getBtnState('approval') == 'approval'" @click="pass()"
          >通过</el-button
        >
        <el-button type="primary" size="small" v-show="getBtnState('revoke') == 'revoke'" @click="cancel()"
          >撤销</el-button
        >
        <!-- <el-button type="primary" size="small" v-show="getBtnState('again') == 'again'" @click="reSubmit()">重新提交</el-button> -->
      </div>
      <!-- end of bottom-btn -->
    </div>

     <div class="form-box">
      
    </div>
    <!-- end of form -->

    <!-- end of dialog-驳回 -->
    <el-dialog title="填写驳回备注" :visible.sync="rejectDialogVisible" :width="isLastNode ? '550px' : '430px'">
      <el-input
        style="margin: 10px 0"
        type="textarea"
        :rows="5"
        placeholder="输入驳回理由（必填）"
        v-model="approveSuggest"
        maxlength="100"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <!-- end of dialog-驳回 -->

    <!-- end of dialog-通过 -->
    <el-dialog title="填写通过信息" :visible.sync="passDialogVisible" :width="isLastNode ? '640px' : '430px'">
      <el-form :model="approveForm">
        <template v-if="isLastNode">
          <el-row :span="24">
            <el-col :span="24">
              <el-form-item label-width="111px" style="margin-bottom: 5px">
                <span slot="label"> <span style="color: red">*</span>结算单上传： </span>
                <el-upload
                  class="upload-demo t-left"
                  action="#"
                  ref="settleAttaches"
                  :on-preview="onPreview"
                  :file-list="approveForm.settleAttaches"
                  accept=".xlsx,.docx,.doc,.pdf,.zip"
                  :auto-upload="true"
                  :http-request="changeMainFile"
                  :limit="20"
                  :on-exceed="handleMainExceed"
                >
                  <div class="file-operate" slot="file" slot-scope="{ file }">
                    <div class="file-name">{{ file.name }}</div>
                    <div class="file-preview" @click="handleMainRemove(file)">删除</div>
                    <div class="file-preview" @click="onPreview(file)">查看</div>
                    <div class="file-preview" @click="download(file.path,file.name,file.fileName)">下载</div>
                  </div>
                  <el-button
                    size="mini"
                    icon="el-icon-my-import"
                    style="margin-top: 8px; margin-bottom: 0"
                    type="importNew"
                    >导入文件</el-button
                  >
                </el-upload>
                <div class="import-step-tip">当前支持word、excel、pdf、zip、rar文件，单个文件大小≤{{ fileSize }}M</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label-width="111px">
                <span slot="label"> <span style="color: red">*</span>是否开票： </span>
                <el-select
                  class="fl"
                  size="mini"
                  v-model="isTax"
                  placeholder="是否开票"
                >
                  <el-option label="是" value="Y"></el-option>
                  <el-option label="否" value="N"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="24" v-if="isTax=='Y'">
            <el-col :span="24">
              <el-form-item label-width="111px">
                <span slot="label"> <span style="color: red">*</span>票据上传： </span>
                <el-upload
                  class="upload-demo t-left"
                  action="#"
                  ref="invoiceAttaches"
                  :on-preview="onPreview"
                  :file-list="approveForm.invoiceAttaches"
                  accept=".xlsx,.docx,.doc,.pdf,.zip,.rar,.ofd"
                  :auto-upload="true"
                  :http-request="changeSubFile"
                  :limit="20"
                  :on-exceed="handleSubExceed"
                >
                  <div class="file-operate" slot="file" slot-scope="{ file }">
                    <div class="file-name">{{ file.name }}</div>
                    <div class="file-preview" @click="handleSubRemove(file)">删除</div>
                    <div class="file-preview" @click="onPreview(file)">查看</div>
                    <div class="file-preview" @click="download(file.path,file.name,file.fileName)">下载</div>
                  </div>
                  <el-button
                    size="mini"
                    icon="el-icon-my-import"
                    style="margin-top: 8px; margin-bottom: 0"
                    type="importNew"
                    >导入文件</el-button
                  >
                </el-upload>
                <div class="import-step-tip">当前支持word、excel、pdf、zip、rar、ofd文件，单个文件大小≤{{ fileSize }}M</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" v-if="isTax=='Y'">
            <el-col :span="24">
              <el-form-item label-width="111px">
                <span slot="label"> <span style="color: red">*</span>开票时间： </span>
                <el-date-picker
                  size="mini"
                  style="width: 100%"
                  v-model="approveForm.invoiceDate"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择开票时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="24" v-if="isTax=='Y'">
            <el-col :span="24">
              <el-form-item label-width="111px">
                <span slot="label"> <span style="color: red">*</span>发票税率(%)： </span>
                <el-input
                  size="mini"
                  type="text"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                  maxlength="5"
                  v-model="approveForm.taxRate"
                  placeholder="请填写税率"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :span="24">
            <el-col :span="24">
              <el-form-item label-width="111px">
                <span slot="label"> <span style="color: white">*</span>备注说明： </span>
                <el-input
                  type="textarea"
                  :rows="5"
                  placeholder="请填写通过备注（选填）"
                  v-model="approveForm.approveSuggest"
                  maxlength="100"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-else>
          <el-input
            style="margin: 10px 0"
            type="textarea"
            :rows="5"
            placeholder="请填写通过备注（选填）"
            v-model="approveForm.approveSuggest"
            maxlength="100"
          >
          </el-input>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
    <!-- end of dialog-通过 -->

    <!-- 财务审批通过 多个付款银行信息 -->
    <PassMultipleDialog
      ref="passMultipleDialogRef"
      :onChangeFullscreenLoading="onChangeFullscreenLoading"
    ></PassMultipleDialog>
    
    <!-- 最后一个节点审批通过 -->
    <LastNodePassDialog
      ref="lastNodePassDialogRef"
      :onChangeFullscreenLoading="onChangeFullscreenLoading"
    ></LastNodePassDialog>
  </div>
</template>

<script>
import {download} from '@/uilt/download'
import workFlowCommon from '@/uilt/workFlowCommon';
import store from '@/store';
import print from 'print-js';
import getTenantDetail from '../../mixins/getTenantDetail';
import PassMultipleDialog from './components/PassMultipleDialog.vue';
import LastNodePassDialog from './components/LastNodePassDialog.vue'
import PayerInfo from './components/PayerInfo.vue';
import BillingInformation from './components/BillingInformation.vue';
import { ServiceProviderTypeEnum } from '../../mixins/getTenantDetail'
import { OrderTypeEnum } from './enum'
export default {
  components: {
    BillingInformation,
    PayerInfo,
    PassMultipleDialog,
    LastNodePassDialog,
    // 流程图渲染库体积大，随组件拆成独立 chunk，进页面后再拉取
    ApprovalProcess: () => import('@/components/ApprovalProcess/index'),
  },
  mixins:[getTenantDetail],
  data() {
    return {
      ServiceProviderTypeEnum,
      detailListData:{},
      download,//下载时保留文件名
      fullscreenLoading: false,
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      guid: '',
      formData: {
        relevance: '', // 关联流程
        payTime: '', // 付款时间
        isInvoiced: '', // 是否已开票
      },

      tableData: [
        {
          key: 1,
          taskContent: '结算金额(元)',
          settleAmount: 'settleAmount',
          memo: '个人结算明细表',
        },
        {
          key: 2,
          taskContent: '结算人数(个)',
          settleAmount: 'personNum',
          memo: '详见结算明细表',
        },
        {
          key: 3,
          taskContent: '服务费(元)',
          settleAmount: 'serviceAmount',
          memo: '服务费费率',
        },
        {
          key: 4,
          taskContent: '结算总额(元)',
          settleAmount: 'payable',
          memo: '结算金额+服务费金额',
        },
      ],

      // 拒绝 通过
      rejectDialogVisible: false,
      passDialogVisible: false,
      approveSuggest: '',
      fileSize: serverConfig.FILE_SIZE,

      approveForm: {
        approveSuggest: null,
        invoiceDate: null,
        settleAttaches: [], //结算
        invoiceAttaches: [],
        taxRate: null,
      },
      isLastNode: false,
      isTax:'Y',
      oldServiceTenantName:'',
      newServiceTenantName:'',
      processNodes: [],
    };
  },
  created() {
    this.guid = this.$route.query.guid;
    this.getDetailData();
    this.judgeCurrentLastNode();
    this.getProcessNodes();
    this.Mixins_getServiceProviderType();
  },
  watch: {},
  computed: {
    /** 一卡多票 */
    oneCardMultipleTickets() {
      return this.formData.payBankInfoList?.length == 1 && this.formData.invoiceAttaches?.length > 1;
    },
    /**是否开票  */
    isInvoicedCom() {
      return this.formData.isInvoiced === 'Y';
    },
    /**整个流程结束 并且 审批状态为通过 */
    isLastNodePass() {
      return this.formData.approveVO?.approveState === 'Y';
    },
    isThirdPartyContractor() {
      try {
        // 可以直接访问到 mixins 中的 data 变量
        const { serviceProviderType } = this.Mixins_tenantDetail.servicerCredential;
        return serviceProviderType === ServiceProviderTypeEnum.THIRD_PARTY_CONTRACTOR;
      } catch (error) {
        console.log(error);
      }
    },
    isMultiplePayBank() {
      // 是否是多个付款银行
      return this.formData.payBankInfoList?.length > 1;
    },
    paymentSettleList() {
      let arr = []
      Array.isArray(this.formData.paymentSettleList) && this.formData.paymentSettleList.forEach(item=>{
        let accountMonth = item.accountMonth ? JSON.parse(item.accountMonth) : [];
        item.relevance = `${item['applyStaffName']} _ ${item['tenantName']} _ ${accountMonth.join(' , ')}${(item['payable'] ? ' _ ' + this.formatMoney(item['payable']) + '(元)' : '')}`
        arr.push(item)
      })
      return arr
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        path: "/downstreamSettlement",
      });
    },
    getName(name, key) {
      const list = this.getCodeListByKey(key);
      const item = list?.find((item) => item.value == name);
      return item?.text || '-';
    },
    
    getProcessNodes() {
      const self = this;
      const approveVO = JSON.parse(this.$route.query.approveVO);
      const params = {
        deploymentId: approveVO.camundaDeploymentId,
        processInstanceId: approveVO.camundaInstanceId,
      }
      self.api.postJson(`/camunda-server/process-definition/get-process-nodes`, params).then((res) => {
        let { code, data, msg } = res.data;
        if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.processNodes = data;
        } else {
          self.$message.error(msg);
        }
      });

    },
    //状态图片
    getApproveImg() {
      return workFlowCommon.getApproveImg(this.formData.approveVO && this.formData.approveVO.approveState);
    },
    judgeCurrentLastNode() {
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      let approveVO = JSON.parse(this.$route.query.approveVO);
      console.log(approveVO);
      let req = {
        deploymentId: approveVO.camundaDeploymentId,
        processInstanceId: approveVO.camundaInstanceId,
        staffGuid: userInfo.staffGuid,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/is-my-last-node`, req).then((res) => {
        let { code, data, msg } = res.data;
        if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.isLastNode = data;
        } else {
          self.$message.error(msg);
        }
      });
    },
    onPreview(file) {
      var fileSuffix;
      if (file.name) {
        fileSuffix = file.name ? file.name.substring(file.name.lastIndexOf('.') + 1) : '';
      }
      if (file.fileName) {
        fileSuffix = file.fileName ? file.fileName.substring(file.fileName.lastIndexOf('.') + 1) : '';
      }
      if (fileSuffix=='ofd') {
        return window.open("https://ofd.xdocin.com/view?src=" + encodeURIComponent(file.path)); 
      }

      if (
        fileSuffix === 'png' ||
        fileSuffix === 'jpeg' ||
        fileSuffix === 'jpg' ||
        fileSuffix === 'pdf' ||
        fileSuffix === 'zip' ||
        fileSuffix === 'rar'
      ) {
        return window.open(file.path);
      }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + file.path);
    },
    onDownload(file) {
      window.open(file.path + '?response-content-type=application/octet-stream');
    },
    onViewUpstreamOperationReportDetail() {
      let query = {
        guid: this.formData.operationReportGuid,
        camundaInstanceId: this.formData.operationReport.approveVO.camundaInstanceId,
        camundaDeploymentId: this.formData.operationReport.approveVO.camundaDeploymentId,
      };
      this.$router.push({
        path: '/upstreamOperationReportDetail',
        query,
      });
    },
    getReciveList(list) {
      let self = this;
      let req = {
        streamType: '1',
        pageIndex: 1,
        pageSize: -1,
        serviceTenantGuid: localStorage.guid,
        isRelationship: 'Y',
        guids: list,
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/invoiceItem/page-list`, req).then((res) => {
        let { code, data, msg } = res.data;
        let listValue = [];
        if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let reciveList = data.records;
          Array.isArray(list) && list.forEach((el) => {
            reciveList.forEach((j) => {
              if (el == j.guid) {
                listValue.push(
                  j.receiveDate +
                    '收款<span style="color: rgb(255, 95, 31);">' +
                    this.formatMoney(j.receiveAmount) +
                    '</span>元',
                );
              }
            });
          });
          console.log(listValue);
          this.formData['upstreamInvoiceItem'] = listValue.join('<br>');
        } else {
          self.$message.error(msg);
        }
      });
    },
    /**
     * 关联下游退款
     */
    getDownstreamRefund(list) {
      let self = this;
      let req = {
        streamType: 3,
        pageIndex: 1,
        pageSize: -1,
        serviceTenantGuid: localStorage.guid,
        isRelationship: 'Y',
        guids: list,
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/invoiceItem/page-list`, req).then((res) => {
        let { code, data, msg } = res.data;
        let listValue = [];
        if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let downstreamRefundList = data.records;
          list && list.forEach((el) => {
            downstreamRefundList.forEach((j) => {
              if (el == j.guid) {
                listValue.push(
                  j.receiveDate +
                    '退款<span style="color: rgb(255, 95, 31);">' +
                    this.formatMoney(j.receiveAmount) +
                    '</span>元',
                );
              }
            });
          });
          if (listValue.length) {
            this.formData['downstreamBackInvoiceItem'] = listValue.join('<br>');
          } else {
            this.formData['downstreamBackInvoiceItem'] = listValue;
          }
        } else {
          self.$message.error(msg);
        }
      });
    },
    async getDetailList(detailData) {
      const guids = detailData.paymentSettleList?.map(item=>item.settleGuid)
      if(!guids?.length) {
        // 没有关联的结算单 or 对账单
        this.detailListData = {
          settleDetail: this.formData.payBankInfoList || [],
        }
        return;
      }
      let url = `/downstream/settle/detail-list`
      if(this.formData.parentBillType == 3) {
        // 证明提交的时候 用的是对账单提交的
        url = `/downstream/statement/detail-list`
      }
      this.fullscreenLoading = true;
      const { data } = await this.api.postJson(`/${serverConfig.msSalesPerformService}${url}`, guids)
      this.fullscreenLoading = false;
      if(data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      // 这个接口里面的 settleDetail 是多个的 另一个详情里面的 settleDetail 是单个的
      // 所以这里调用了该接口
      this.detailListData = data.data;
    },
    /**
     * 获取详情
     */
    getDetailData() {
      let self = this;
      let userinfo = JSON.parse(localStorage.userInfo);
      this.fullscreenLoading = true;
      self.api
        .get(`/${serverConfig.msSalesPerformService}/downstream/payment/detail/${self.$route.query.guid}`)
        .then((res) => {
          this.fullscreenLoading = false;
          let { code, data, msg } = res.data;
          if (code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (data.servicerGuid && data.servicerGuid != data.serviceTenantGuid) {
              this.oldServiceTenantName = data.serviceTenantName;
              this.newServiceTenantName = data.servicerName;
            } else {
              this.oldServiceTenantName = data.serviceTenantName;
              this.newServiceTenantName = ''
            }
            data.serviceTenantName = data.servicerName || data.serviceTenantName;
            data.serviceTenantGuid = data.servicerGuid || data.serviceTenantGuid;
            const operationReportTenantName =
              data.operationReport?.taskTitleName?.split("-")?.[1];
            const operationReportAccountMonth =
              data.operationReport?.accountMonth || "";
            const operationReportCurrentPayAmount =
              data.operationReport?.currentPayAmount || "";
            let operationReportName = '';
            if (data.operationReportGuid) {
              operationReportName = `${data.applyStaffName}_${operationReportTenantName}_${operationReportAccountMonth}_${operationReportCurrentPayAmount}(元)`;
            }

            this.formData = {
              ...data,
              operationReportName: operationReportName,
            };
            this.formData.payBankInfoList = this.formData.payBankInfoList?.map((item,index) => {
              return {
                ...item,
                invoiceCategory: this.formData.invoiceAttaches?.[index]?.invoiceCategory,
              }
            })
            console.log(data);
            let accountMonth = data.accountMonth ? JSON.parse(data.accountMonth) : [];
            // 显示发起人 + 药企简称 + 月份 + 应付金额
            this.formData['relevance'] =
              data['applyStaffName'] +
              ' _ ' +
              data['tenantName'] +
              ' _ ' +
              accountMonth.join(' , ') +
              (data['payable'] ? ' _ ' + this.formatMoney(data['payable']) + '(元)' : '');
            if (this.formData['paymentAttaches'] && this.formData['paymentAttaches'].length) {
              this.formData['paymentAttaches'].forEach((item) => {
                item.name = item.fileName;
              });
            }
            this.getDetailList(data);
            if (data.isRepay == 'Y') {
              this.getReciveList(data.upstreamInvoiceItem);
              this.getDownstreamRefund(data.downstreamBackInvoiceItem);
            }
          } else {
            self.$message.error(msg);
          }
        });
    },
    /**
     * 获取操作按钮显隐
     * @param {*} btnType
     */
    getBtnState(btnType) {
      if (this.$route.query.approveVO) {
        let userinfo = JSON.parse(localStorage.userInfo);
        let approveVO = JSON.parse(this.$route.query.approveVO);
        return workFlowCommon.getListBtnState(
          btnType,
          approveVO.approveState,
          approveVO.staffGuid,
          approveVO.approveStaffGuids,
          userinfo.staffGuid,
          approveVO.approveState,
        );
      }
    },
    /**
     * 校验付款单 付款状态是否允许操作
     * 2026-08-31 应测试要求，暂时注释掉"该流程已付款，不允许驳回/撤销"的前端拦截，一律放行；如需恢复，取消下方代码注释即可
     * @param {string} operationType - 操作类型：'revoke' 撤销 或 'reject' 驳回
     * @returns {boolean} - true表示允许操作，false表示不允许
     */
    checkPaymentStatus(operationType) {
      // let { financeApproveState, approveVO } = this.formData;
      // const isPaid = financeApproveState === 'Y' && approveVO?.flowType === OrderTypeEnum.PAYMENT;
      // 付款单已经 财务付款确认审批通过了 不允许驳回/撤销
      // if (isPaid) {
      //   const actionMap = {
      //     'revoke': '撤销',
      //     'reject': '驳回'
      //   };
      //   const action = actionMap[operationType] || '操作';
      //   this.$message.error(`该流程已付款，不允许${action}`);
      //   return false;
      // }
      return true;
    },
    /**
     * 驳回
     */
    reject() {
      if (!this.checkPaymentStatus('reject')) return;
      this.rejectDialogVisible = true;
      this.approveSuggest = '';
    },
    onChangeFullscreenLoading(val) {
      this.fullscreenLoading = val;
    },
    /**
     * 通过
     */
    pass() {
      // this.passDialogVisible = true;
      // 当前 [财务签收确认] 节点
      let isCurrFinanceNode = false;
      const currFinanceNode = this.processNodes?.find(item => item.processName === '财务签收确认');
      if (currFinanceNode.staffVOS) {
        const approval = currFinanceNode.staffVOS?.find(item => item.approvalState === 'A')
        if (approval) {
          isCurrFinanceNode = true
        }
      }
      const userInfo = JSON.parse(localStorage.userInfo);
      const { approveVO } = this.formData;

      const passMultipleData = {
        settleDetail: this.detailListData.settleDetail?.map((item,index) => {
          return {
            ...item,
            // payAmount: item.totalAmount,
            payAmount: this.formData.payAmount ? this.formData.payAmount : '0',
            payBankName: this.formData.payBankInfoList[index]?.payBankName,
            payBankAccount: this.formData.payBankInfoList[index]?.payBankAccount,
          }
        }) || [],
        newServiceTenantName: this.newServiceTenantName,
        newServicerGuid: this.formData.servicerGuid,
        serviceTenantName: this.formData.serviceTenantName,
        oldServiceTenantName: this.oldServiceTenantName,
        oldServicerGuid: this.formData.serviceTenantGuid,
        payAmount:  this.formData.payAmount ? this.formatMoney(this.formData.payAmount) : '-' ,
        approveSuggest: this.approveSuggest,
        guid: this.$route.query.guid,
        approveStaffGuid: userInfo.staffGuid,
        approveGuid: approveVO.approveGuid,
      };
      // 当前 [财务付款确认,财务付款信息录入] 节点
      const currFinancialPaymentConfirmationNode = this.processNodes?.find(item => item.processName === '财务付款确认' || item.processName === '财务付款信息录入');
      if (currFinancialPaymentConfirmationNode.staffVOS) {
        const approval = currFinancialPaymentConfirmationNode.staffVOS?.find(item => item.approvalState === 'A')
        if (approval) {
          this.$refs.passMultipleDialogRef.open(passMultipleData);
          return
        }
      }
      // (不是财务签收确认 or 只有单个付款银行) 并且 不是最后节点
      if ((!isCurrFinanceNode || this.formData.payBankInfoList?.length == 1) && !this.isLastNode) {
        this.passDialogVisible = true;
        return;
      }
      // 不是最后节点
      // if (!this.isLastNode) {
      //   this.$refs.passMultipleDialogRef.open(passMultipleData);
      //   return;
      // }

      const lastNodePassDialogData = {
        approveForm: {
          ...this.approveForm,
          settleDetail: this.detailListData?.settleDetail || [],
        },
        paymentSettleList: this.paymentSettleList,
        parentBillType: this.formData.parentBillType,
        operationReportTenantGuid: this.formData.operationReportTenantGuid,
        approveVO,
      }
      // 最后一个节点
      if (this.isLastNode) {
        this.$refs.lastNodePassDialogRef.open(lastNodePassDialogData);
      }
      this.approveSuggest = '';
    },
    /**
     * 撤销
     */
    cancel() {
      if (!this.checkPaymentStatus('revoke')) return;
      let self = this;
      let { approveVO } = this.formData;
      this.$confirm('撤销后,该流程将不再进行审核,确定这样操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let query = {
            guid: approveVO.approveGuid,
            flowType: approveVO.flowType,
            approveStaffGuid: approveVO.staffGuid,
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success('撤销成功！');
              // 最后一个节点
              if (self.isLastNode) {
                self.$router.replace('/hedgeAmount');
                return;
              }
              self.$router.go(-1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          });
        });
    },
    /**
     * 驳回提交
     */
    toRejectSubmit() {
      if (!this.approveSuggest) {
        return this.$message.error('请填写驳回理由');
      }
      let userInfo = JSON.parse(localStorage.userInfo);
      let { approveVO } = this.formData;
      let query = {
        guid: approveVO.approveGuid,
        flowType: approveVO.flowType,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userInfo.staffGuid,
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.passDialogVisible = false;
          this.approveSuggest = '';
          this.$message.success('驳回成功！');
          this.$router.go(-1);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    /**
     * 通过提交
     */
    toPassSubmit() {
      let userInfo = JSON.parse(localStorage.userInfo);
      let { approveVO } = this.formData;
      let approveForm = JSON.parse(JSON.stringify(this.approveForm));
      let query = {
        guid: approveVO.approveGuid,
        flowType: approveVO.flowType,
        approveSuggest: approveForm.approveSuggest,
        approveStaffGuid: userInfo.staffGuid,
      };

      if (this.isLastNode) {
        if (!approveForm.settleAttaches.length) {
          this.$message.error('请上传结算单');
          return;
        }
        if(this.isTax=='N'){
          approveForm.invoiceAttaches=[]
          approveForm.invoiceDate=null
          approveForm.taxRate=null
        }
        if (this.isTax=='Y'&&!approveForm.invoiceAttaches.length) {
          this.$message.error('请上传票据');
          return;
        }
        if (this.isTax=='Y'&&!approveForm.invoiceDate) {
          this.$message.error('请填写开票时间');
          return;
        }
        if (this.isTax=='Y'&&!approveForm.taxRate) {
          this.$message.error('请填写发票税率');
          return;
        }
        if (approveForm.settleAttaches.length) {
          approveForm.settleAttaches.forEach((item) => {
            item.fileName = item.name;
          });
        }
        if (approveForm.invoiceAttaches.length) {
          approveForm.invoiceAttaches.forEach((item) => {
            item.fileName = item.name;
          });
        }
        query = {
          approveSuggest: approveForm.approveSuggest,
          approveStaffGuid: userInfo.staffGuid,
          approveGuid: approveVO.approveGuid,
          guid: this.$route.query.guid,
          settleAttaches: approveForm.settleAttaches,
          invoiceAttaches: approveForm.invoiceAttaches,
          invoiceDate: approveForm.invoiceDate, //票据
          taxRate: approveForm.taxRate, //税率
        };
        this.fullscreenLoading = true;
        this.api
          .postJson(`/${serverConfig.msSalesPerformService}/downstream/payment/submit-approve-last`, query)
          .then((res) => {
            this.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.passDialogVisible = false;
              this.$message.success('审批通过！');
              this.$router.go(-1);
            } else {
              this.$message.error(res.data.msg);
            }
          });
      } else {
        this.fullscreenLoading = true;
        this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.passDialogVisible = false;
            this.$message.success('审批通过！');
            this.$router.go(-1);
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    /**
     * 打印
     */
    billPrintClick() {
      let str = '结算单';
      const style = '@page {margin:0 10mm};'; //打印时去掉眉页眉尾
      printJS({
        printable: 'printBill', // 标签元素id
        type: 'html',
        header: '',
        documentTitle: str,
        targetStyles: ['*'],
        style,
        ignoreElements: ['baseInfo', 'printBtn', 'baseInfo1', 'baseInfo2'],
      });
      // 各个配置项
      // printable:要打印的id。
      // type:可以是 html 、pdf、 json 等。
      // properties:是打印json时所需要的数据属性。
      // gridHeaderStyle和gridStyle都是打印json时可选的样式。
      // repeatTableHeader:在打印JSON数据时使用。设置为时false，数据表标题将仅在第一页显示。
      // scanStyles:设置为false时，库将不处理应用于正在打印的html的样式。使用css参数时很有用，此时自己设置的原来想要打印的样式就会失效，在打印预览时可以看到效果
      // targetStyles: [’*’],这样设置继承了页面要打印元素原有的css属性。
      // style:传入自定义样式的字符串，使用在要打印的html页面 也就是纸上的样子。
      // ignoreElements：传入要打印的div中的子元素id，使其不打印。非常好用
    },
    /**
     * 查看对账单
     */
    see(url) {
      if (!url) {
        return;
      }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + url);
    },
    /**
     * 数字金额转大写
     * @param {*} num
     */
    convertToChinese(num) {
      const digits = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
      const decimals = ['角', '分'];
      const cnIntRadice = ['', '拾', '佰', '仟'];
      const cnIntUnits = ['', '万', '亿', '兆'];

      let cnNum = '';
      let isNegative = false;

      if (num < 0) {
        isNegative = true;
        num = Math.abs(num);
      }

      let parts = String(num).split('.');
      let integerPart = parts[0];
      let decimalPart = parts[1];

      if (Number(integerPart) === 0) {
        cnNum = digits[0];
        return cnNum;
      }

      let intLen = integerPart.length;
      let zeroCount = 0;

      for (let i = 0; i < intLen; i++) {
        let n = parseInt(integerPart.charAt(i));
        let p = intLen - i - 1;
        let q = p / 4;
        let m = p % 4;

        if (n === 0) {
          zeroCount++;
        } else {
          if (zeroCount > 0) {
            cnNum += digits[0];
          }
          zeroCount = 0;
          cnNum += digits[n] + cnIntRadice[m];
        }

        if (m === 0 && zeroCount < 4) {
          cnNum += cnIntUnits[q];
        }
      }

      if (decimalPart) {
        let decLen = decimalPart.length;
        for (let i = 0; i < decLen; i++) {
          let n = parseInt(decimalPart.charAt(i));
          if (n !== 0) {
            cnNum += digits[n] + decimals[i];
          }
        }
      }

      if (isNegative) {
        cnNum = '负' + cnNum;
      }

      return cnNum;
    },
    /********附件上传************/
    // 上传文件
    changeMainFile(file) {
      let isLt5M = file.file.size / 1024 / 1024 < this.fileSize;
      if (!isLt5M) {
        this.$message.error(`上传文件大小不能超过${this.fileSize}MB`);
        this.$refs.settleAttaches.clearFiles(); // 清除前端显示的文件列表
        return;
      }
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('fileName', file.file.name);
      this.fullscreenLoading = true;
      this.api
        .postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.approveForm.settleAttaches.push({
              name: file.file.name,
              path: res.data.data.data,
            });
            console.log(this.approveForm.settleAttaches);
            this.$message({
              message: '上传成功',
              type: 'success',
            });
          } else {
            this.approveForm.settleAttaches = [];
            this.$message.error('上传失败!');
          }
        })
        .catch(() => {
          this.$message('上传失败！');
        });
    },
    handleMainExceed(files, fileList) {
      this.$message.warning(`当前限制选择 20 个文件`);
    },
    handleMainRemove(file) {
      this.approveForm.settleAttaches.forEach((item, index) => {
        if (item.path == file.path) {
          this.approveForm.settleAttaches.splice(index, 1);
        }
      });
    },
    changeSubFile(file) {
      let isLt5M = file.file.size / 1024 / 1024 < this.fileSize;
      if (!isLt5M) {
        this.$message.error(`上传文件大小不能超过${this.fileSize}MB`);
        this.$refs.invoiceAttaches.clearFiles(); // 清除前端显示的文件列表
        return;
      }
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('fileName', file.file.name);
      this.fullscreenLoading = true;
      this.api
        .postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.approveForm.invoiceAttaches.push({
              name: file.file.name,
              path: res.data.data.data,
            });
            this.$message({
              message: '上传成功',
              type: 'success',
            });
          } else {
            this.approveForm.invoiceAttaches = [];
            this.$message.error('上传失败!');
          }
        })
        .catch(() => {
          this.$message('上传失败！');
        });
    },
    handleSubExceed(files, fileList) {
      this.$message.warning(`当前限制选择 20 个文件`);
    },
    handleSubRemove(file) {
      this.approveForm.invoiceAttaches.forEach((item, index) => {
        if (item.path == file.path) {
          this.approveForm.invoiceAttaches.splice(index, 1);
        }
      });
    },
    /**
     * 数字金额转大写
     * @param {*} num
     */
    formatMoney(num) {
      // 将数字转换为字符串并保留两位小数
      num = num.toFixed(2);

      // 将字符串按小数点分割成整数部分和小数部分
      var parts = num.toString().split('.');

      // 将整数部分每三位加一个逗号
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      // 将整数部分和小数部分拼接起来
      return parts.join('.');
    },
    seeDetail(settleGuid) {
      let url = '/settlementDocDetail'
      if(this.formData.parentBillType == 3){
        url = '/settlementBillDetail'
      }
      url += '?guid=' + settleGuid;
      window.open(url);
    },
  },
};
</script>

<style lang="less" scoped>
.import-step-tip {
  text-align: left;
  font-size: 12px;
  line-height: 20px;
}

.file-operate {
  display: flex;
}

.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
  word-break: keep-all;
}

.content {
  padding: 0px;
  margin: 0px;

  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;

    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }

    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }

  .mt-4 {
    margin-top: 4px;
    padding-bottom: 10px;
  }

  .form-box {
    margin-top: 4px;
    text-align: left;

    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
      font-weight: 700;
    }
    .form-title-item {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      font-weight: 600;
      margin-left: 44px;
    }

    .form-task-title-item {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      font-weight: 600;
      margin-left: 44px;
    }

    /deep/ .el-row {
      margin: 0px !important;
    }

    .el-form-item {
      margin-bottom: 0px;
    }

    .over-label /deep/ .el-form-item__label {
      line-height: 21px;
    }

    .el-input {
      width: 220px;
    }

    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;

      .el-button--primary {
        color: #ffffff;
      }
    }
  }

  /deep/ .el-dialog__header {
    text-align: left;
    border-bottom: 1px solid #d9d9d9;
  }

  /deep/ .el-dialog__body {
    padding: 0px 20px;
  }

  /deep/ .el-dialog__footer {
    padding: 10px 20px;
    border-top: 1px solid #d9d9d9;
  }

  .flow {
    background: #fff;
    padding-left: 20px;
  }

  .detail-box {
    height: auto;
    border: 1px solid rgba(217, 217, 217, 1);
    margin: 0px 16px;
    padding: 16px 16px 100px 16px;
  }

  .cannel-btn {
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    color: #212121;
  }

  .content-main-box2 {
    height: 55vh;
    overflow-x: hidden;

    .search-area {
      padding: 16px 0px;
    }

    .el-table {
      border-left: 1px solid #d8d8d8;
      border-right: 1px solid #d8d8d8;
      border-bottom: 1px solid #d8d8d8;
    }
  }

  .file-img-box {
    display: flex;
    align-items: center;

    img {
      width: 26px;
      height: 26px;
      margin-right: 10px;
    }

    .see-btn {
      font-size: 14px;
      color: #4fa1a4;
      letter-spacing: 0;
      line-height: 21px;
      font-weight: 400;
      cursor: pointer;
      margin-left: 10px;
    }
  }

  .flex-between,
  .form-title-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .form-title-box {
    padding-right: 16px;
  }

  h2 {
    text-align: center;
  }

  .txt-right {
    text-align: right;

    span {
      margin: 0px 16px;
    }
  }

  .table1 {
    border: 1px solid rgba(229, 229, 229, 1);
    .header-div {
      background: #f2f2f2;
      font-size: 12px;
      color: #909399;
      letter-spacing: 0;
      text-align: center;
      font-weight: bold;
      height: 32px;
      line-height: 32px;
      border: 1px solid rgba(229, 229, 229, 1);
    }

    .tab-label {
      padding: 0px 10px;
      width: 280px;
      height: 32px;
      color: #212121;
      line-height: 32px;
      background: #fafafa;
      border-bottom: 1px solid rgba(229, 229, 229, 1);
      border-right: 1px solid rgba(229, 229, 229, 1);
      border-left: 1px solid rgba(229, 229, 229, 1);
    }

    .tab-value {
      text-align: right;
      padding: 0px 10px;
      width: calc(100% - 320px);
      height: 32px;
      line-height: 32px;
      border-bottom: 1px solid rgba(229, 229, 229, 1);
      border-right: 1px solid rgba(229, 229, 229, 1);
      color: #666666;
    }

    p {
      color: #666666;
    }

    .line-box {
      height: 32px;
      line-height: 32px;
      border-bottom: 1px solid rgba(229, 229, 229, 1);
      padding-left: 10px;

      div:first-child {
        width: 80px;
        background: #fafafa;
        // border-top: 1px solid rgba(229, 229, 229, 1);
        border-right: 1px solid rgba(229, 229, 229, 1);
        font-weight: bold;
      }

      div:last-child {
        padding: 10px 6px;
        width: calc(100% - 80px);

        // border-top: 1px solid rgba(229, 229, 229, 1);
      }
    }
  }

  .table2,
  .table3 {
    width: 100%;
    td {
      padding: 6px;
      border: 1px solid rgba(229, 229, 229, 1);
      border-right: 0 none;
      border-top: 0 none;
    }
    th {
      border: 1px solid rgba(229, 229, 229, 1);
      border-right: 0 none;
      background: #f2f2f2;
      padding: 6px;
    }
    td:last-child {
      border-right: 1px solid rgba(229, 229, 229, 1);
    }
  }

  .table2 {
    margin: 16px 0px;
  }

  .info-box {
    width: 390px;
  }
}
.wth800 {
  width: 800px;
}
.approve-img {
  position: absolute;
  top: 2%;
  right: 60px;
  width: 78px;
  height: 78px;
}
</style>
